import { SET_RENDERING_ENV } from './const';

/**
 * Returns action for setting rendering environment
 * @param {object} payload - contains pageType and pageTemplateName
 * @returns {object} Action Object
 */
export const setRenderingEnv = payload => ({
  type: SET_RENDERING_ENV,
  payload
});
